import React, { Component } from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleButton from "../../../../modules/commons/SimpleButton";

class InventoryPartDownloadModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCabang: [],
    };
  }

  handleSelectCabang = (value) => {
    this.setState({
      selectedCabang: value,
    });
  };

  render() {
    const { visible, onClickClose, cabangOptions, onSubmit } = this.props;
    const { selectedCabang } = this.state;
    return (
      <React.Fragment>
        <SimpleModal
          visible={visible}
          styles={{ width: "40%" }}
          title="Cetak Inventory"
          onClickClose={onClickClose}
          content={
            <ModalContainer>
              <FlexView style={{ gap: "15px" }} vAlignContent="center">
                <h4 className="txt-site txt-15 margin-bottom-20px">Cabang</h4>
                <SimpleDDL
                  id="select_branch_cetak"
                  options={cabangOptions}
                  containerclassname="flex-1"
                  box="multiselect"
                  value={selectedCabang}
                  onChange={(val) => this.handleSelectCabang(val)}
                />
              </FlexView>
              <FlexView hAlignContent="right">
                <SimpleButton
                  id="button_print"
                  text="Print"
                  onClick={() => onSubmit(selectedCabang)}
                />
              </FlexView>
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default InventoryPartDownloadModal;
